import { PropsWithChildren } from 'react';

import {
  numberParam,
  ParamNamespace,
  ParamProvider,
  useParamsContext,
} from '@sbv-clients/shared-state';

const paramsConfig = {
  facilityId: numberParam({ default: null, persist: true, supportNull: true }),
  departmentId: numberParam({
    default: null,
    persist: true,
    supportNull: true,
  }),
};

export const PageParamsProvider = (props: PropsWithChildren) => {
  return (
    <ParamProvider
      schema={paramsConfig}
      namespace={ParamNamespace.FacilityDashboard}
    >
      {props.children}
    </ParamProvider>
  );
};

export const usePageParamsContext = () =>
  useParamsContext<typeof paramsConfig>();
